<template>
    <nav
        class="navbar navbar-expand-lg navbar-dark"
        style="background-color: #231F20"
    >
        <a
            class="navbar-brand d-lg-none"
            href="https://onegenlab.com"
            target="_blank"
        >
            <img
                alt="Onegen Lab"
                class="d-inline-block align-top"
                height="60"
                src="./../../images/only-logo.png"
                width="auto"
            />
            <span class="logo-text-bold">onegen</span
            ><span class="logo-text-light"> lab</span>
        </a>

        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarToggle"
            aria-controls="navbarToggle"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>

        <div
            class="collapse navbar-collapse justify-content-between"
            id="navbarToggle"
        >
            <a
                class="navbar-brand d-none d-lg-block"
                href="https://onegenlab.com"
                target="_blank"
            >
                <img
                    alt="Onegen Lab"
                    class="d-inline-block align-top"
                    height="60"
                    src="./../../images/only-logo.png"
                    width="auto"
                />
                <span class="logo-text-bold">onegen</span
                ><span class="logo-text-light"> lab</span>
            </a>

            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://onegenlab.com/como-funciona/"
                        target="_blank"
                    >
                        {{ $t("navbar.how-it-works") }}
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://onegenlab.com/que-es-el-adn/"
                        target="_blank"
                    >
                        {{ $t("navbar.what-is-dna") }}
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://onegenlab.com/test-genetico/"
                        target="_blank"
                    >
                        {{ $t("navbar.our-tests") }}
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://onegenlab.com/nuestro-laboratorio/"
                        target="_blank"
                    >
                        {{ $t("navbar.our-lab") }}
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://onegenlab.com/contacto/"
                        target="_blank"
                    >
                        {{ $t("navbar.contact") }}
                    </a>
                </li>
            </ul>

            <locale-switcher />
        </div>
    </nav>
</template>

<script>
import LocaleSwitcher from "./LocaleSwitcher";

export default {
    computed: {
        currentLocale() {
            return this.$route.params.locale;
        }
    },
    components: {
        LocaleSwitcher
    }
};
</script>

<style scoped></style>
